import styled from 'styled-components';

export const StyledTitle = styled.h4<{
  $darkened?: boolean;
  $marginTop?: number;
  $marginBottom?: number;
  $align?: 'left' | 'center' | 'right';
}>`
  font-family: ${({ theme }) => theme.fontFamily.special};
  font-size: 21px;
  color: ${({ theme, $darkened }) => $darkened ? theme.colors.white : theme.colors.black};
  font-weight: 700;
  margin-top: 0;
  margin-top: ${({ $marginTop }) => $marginTop}px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;
  line-height: 1.1;
  ${({ $align }) => $align && `text-align: ${$align};`}
`;
